// TODO: load mode from async storage
import { DefaultTheme, Theme } from '@react-navigation/native';
import { ColorValue, Dimensions, Platform, StatusBar } from 'react-native';

const hasNotch: boolean = StatusBar?.currentHeight! > 24;
const { width } = Dimensions.get('window');

type ThemeMode = 'light' | 'dark';
interface ComponentProp {
  [key: string]: string | number | boolean;
}

const chartConfig = {
  backgroundGradientFrom: '#FFF',
  backgroundGradientFromOpacity: 0,
  backgroundGradientTo: '#FFF',
  backgroundGradientToOpacity: 1,
  color: () => `#000`,
  strokeWidth: 1, // optional, default 3
  barPercentage: 0.5,
  useShadowColorFromDataset: true, // optional
};


export const gradients = {
  primary: {
    colors: ["#0059D4", "#013174", "rgba(0, 0, 0, 0.5)"] as readonly [ColorValue, ColorValue, ...ColorValue[]],
    locations: [0, 0.9999, 1] as readonly [number, number, ...number[]],
  },
  white: {
    colors: ["#FFF", "#FFF"] as readonly [ColorValue, ColorValue, ...ColorValue[]],
    locations: [0, 1] as readonly [number, number, ...number[]],
  },
  test1: {
    colors: ["#0059D4", "#013174", "rgba(0, 0, 0, 0.5)"] as readonly [ColorValue, ColorValue, ...ColorValue[]],
    locations: [0, 0.9999, 1] as readonly [number, number, ...number[]],
  },
  test2: {
    colors: ["#292C28", "#1C5576"] as readonly [ColorValue, ColorValue, ...ColorValue[]],
    locations: [0.08, 0.54] as readonly [number, number, ...number[]],
  },
};

const palette = {
  light: {
    background: '#F5F5F5',
    textColor: '#3D3D3D',
    accentColor: '#005ACE',
    mask: '#FFF',

    blue: `#005ACE`,
    white: `#FFFFFF`,
    green: '#27AE60',
    red: `#EB5757`,
    black: `#000000`,
    gray_1: `#F5F5F5`,
    gray_2: `#838383`,
    gray_3: `#CCC`,
  },
  dark: {
    background: '',
    textColor: '',
    accentColor: '',
    mask: '',

    blue: '',
    white: '',
    green: '',
    red: '',
    black: '',
    gray_1: '',
    gray_2: '',
    gray_3: '',
  },
};

type ColorPalette = {
  background: string;
  textColor: string;
  accentColor: string;
  mask: string;

  blue: string;
  white: string;
  green: string;
  red: string;
  black: string;
  gray_1: string;
  gray_2: string;
  gray_3: string;
};



export type AppTheme = Theme & {
  mode: ThemeMode;
  isDark: Boolean;
  isLight: Boolean;
  headerHeight: Number;
  buttonHeight: Number;
  navHeight: Number;
  chartConfig: Object;
  fontSize: Number;
  contentWidth: Number;
  columnWidth: Number;
  gradients: typeof gradients;
  pallete: ColorPalette;
};

export type EmotionProp = ComponentProp & {
  theme: AppTheme;
};

export const contentWidth = Math.min(390, width * 0.90);
export const columnWidth = Math.min(180, (width * 0.90) >> 1);

export default function setTheme(mode: ThemeMode = 'light'): AppTheme {
  return {
    ...DefaultTheme,
    mode,
    isDark: mode === 'dark',
    isLight: mode === 'light',
    chartConfig: chartConfig,
    headerHeight: hasNotch && Platform.OS === 'ios' ? 115 : 60,
    buttonHeight: 41,
    navHeight: 63,
    fontSize: 14,
    contentWidth,
    columnWidth,

    // ...colors,
    // ...palette[mode],
    // colors,
    pallete: palette[mode],
    gradients: gradients,
  };
}
